module.exports = __webpack_public_path__ + "img/coverBanner-ar-responsive.aa4325ed.jpg";